import 'filepond-polyfill';
import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { isMobile } from 'is-mobile';
import sv_SE from 'filepond/locale/sv_se.js';

let pond: FilePond.FilePond;
document.addEventListener('DOMContentLoaded', function (event) {
  FilePond.registerPlugin(FilePondPluginFileValidateType);

  pond = FilePond.create(document.querySelector('#filepond'), {
    acceptedFileTypes: ['image/png, image/jpeg, image/gif, image/heif'],
  });
  sv_SE.labelIdle = 'Drag och släpp din fil eller <span class="filepond--label-action"> Bläddra </span>';
  if (isMobile({ tablet: true })) {
    sv_SE.labelIdle = 'Ta eller välj bild';
  }

  pond.setOptions({
    ...sv_SE,
    credits: false,
    allowRevert: false,

    onaddfile: (error, file) => {
      showLoader(true);
      var fd = new FormData();
      var checkbox = document.querySelector('#imageAddOnExistingPage') as any;
      var contentId = document.querySelector('#addImageContentId') as any;
      var currentPageCheck = 'false';
      if (checkbox != null) {
        currentPageCheck = checkbox.checked;
      }
      fd.append('currentContentId', contentId.value);
      fd.append('addToCurrentPage', currentPageCheck);
      fd.append('file', file.file);

      // @ts-ignore
      $.ajax({
        url: '/mobilbild/uploadimages/',
        data: fd,
        processData: false,
        contentType: false,
        type: 'POST',
        success: function (data) {
          pond.removeFiles();
          showLoader(false);
          showSuccessPopup(true);
        },
        error: function (ex) {
          setResponseMessage('Någonting gick fel vid upppladdningen.', true);
          pond.removeFiles();
          console.error(ex);
          showLoader(false);
        },
      });
    },
  });

  document.querySelector('#addImageCancel')?.addEventListener('click', showAddImageModal);
  document.querySelectorAll('.new-image-button')?.forEach((el) => el.addEventListener('click', showAddImageModal));
});

var showAddImageModal = function () {
  var addImageDialog = document.getElementById('addImageDialog');
  if (addImageDialog.style.display === 'none') {
    addImageDialog.style.display = 'flex';
  } else {
    addImageDialog.style.display = 'none';
    setResponseMessage("", false);
  }
};

var setResponseMessage = function (msg: string, show: boolean) {
  var element = document.getElementById('response-message');
  element.innerText = msg;
  showResponseMessage(show, element);
};

var showResponseMessage = function(show: boolean, element: HTMLElement) {
  if (show) {
    element.style.display = 'block';
  } else {
    element.style.display = 'none';
  }
}

var showLoader = function (show: boolean) {
  var loader = document.querySelector('#addImageDialog .loader-wrapper') as HTMLElement;
  if (show) {
    loader.style.display = 'flex';
  } else {
    loader.style.display = 'none';
  }
};

var showSuccessPopup = function (show: boolean) {
  var message = document.querySelector('#success-message') as HTMLElement;
  var checkbox = document.querySelector('#imageAddOnExistingPage') as any;

  message.style.display = 'flex';
  setTimeout(function () {
    if (checkbox != null && checkbox.checked) {
      location.reload();
    } else {
      message.style.display = 'none';
      showAddImageModal();
      setResponseMessage("", false);
    }
  }, 3000);
};
